import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const LogList = () => {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedProject) {
      setFilteredLogs(logs.filter(log => log.project_id === parseInt(selectedProject)));
    } else {
      setFilteredLogs(logs);
    }
  }, [selectedProject, logs]);

  const fetchData = async () => {
    try {
      const [logsResponse, projectsResponse] = await Promise.all([
        api.get('/logs'),
        api.get('/projects')
      ]);
      setLogs(logsResponse.data);
      setFilteredLogs(logsResponse.data);
      setProjects(projectsResponse.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this log?')) {
      try {
        await api.delete(`/logs/${id}`);
        fetchData();
      } catch (error) {
        console.error('Error deleting log:', error);
        alert('Failed to delete log');
      }
    }
  };

  if (loading) return <div className="loading">Loading logs...</div>;

  return (
    <div className="logs-list">
      <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center', marginLeft: '2rem' }}>
        <button onClick={() => navigate('/logs/new')} className="primary">
          + New Log
        </button>
        
        <select
          value={selectedProject}
          onChange={(e) => setSelectedProject(e.target.value)}
          style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
        >
          <option value="">All Projects</option>
          {projects.map(project => (
            <option key={project.id} value={project.id}>
              {project.name}
            </option>
          ))}
        </select>
      </div>

      <div className="card">
        <h3>Production Logs ({filteredLogs.length})</h3>
        {filteredLogs.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Project</th>
                <th>Element</th>
                <th>Detail</th>
                <th>CY</th>
                <th>Crew</th>
                <th>Hours</th>
                <th>MH/CY</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map(log => (
                <tr key={log.id}>
                  <td>{new Date(log.log_date).toLocaleDateString()}</td>
                  <td>{log.project_name}</td>
                  <td>{log.element_category}</td>
                  <td>{log.element_detail}</td>
                  <td>{log.cubic_yards}</td>
                  <td>{log.crew_size}</td>
                  <td>{log.total_manhours}</td>
                  <td><strong>{log.mh_per_cy}</strong></td>
                  <td>
                    <button 
                      onClick={() => handleDelete(log.id)} 
                      className="danger"
                      style={{ padding: '6px 12px', fontSize: '12px' }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No logs found. Create your first log!</p>
        )}
      </div>
    </div>
  );
};

export default LogList;